import { getRuntimeConfigValue } from '@common/next-runtime-config';

import { useReviewListConfig } from '../context/ReviewListConfigContext';
import { FeedType } from '../types/feed';

export enum UseReviewListUrlNav {
  reveiw_summary_detail,
  browser_best_review,
  browser_product_photo_review_detail,
}

export interface UseReviewListUrlOption {
  product_id?: string;
  title?: string;
  review_id?: string;
  attachment_position?: number;
  thumbnail_index?: number;
  /**
   * api와 추론하기 위한 값
   */
  feedType?: FeedType;
  /**
   * navigation을 추론하기 위한 값
   */
  nav?: UseReviewListUrlNav;
  order_type?: string;
}
export function useReviewListUrl(defaultOption?: UseReviewListUrlOption) {
  const config = useReviewListConfig();
  const base_url = (getRuntimeConfigValue('appUrl') as string) ?? 'https://zigzag.kr';

  return (call_option?: UseReviewListUrlOption) => {
    const option = { ...defaultOption, ...call_option };

    const urlController = new URL(base_url);

    if (option.product_id) {
      urlController.pathname = config.path.review.list(option.product_id);
    }
    if (option.feedType) {
      urlController.searchParams.set('feedType', option.feedType);
    }
    if (option.order_type) {
      urlController.searchParams.set('order_type', option.order_type);
    }
    if (option.title) {
      urlController.searchParams.set('title', option.title);
    }
    if (option.review_id) {
      urlController.searchParams.set('top_id', option.review_id);
    }
    if (option.attachment_position) {
      urlController.searchParams.set('attachment_position', String(option.attachment_position));
    }
    if (option.thumbnail_index) {
      urlController.searchParams.set('thumbnail_index', String(option.thumbnail_index));
    }
    if (typeof option.nav !== 'undefined') {
      urlController.searchParams.set('nav', String(option.nav));
    }
    urlController.search = urlController.searchParams.toString();

    return urlController;
  };
}
